import { fetchAuthSession } from "aws-amplify/auth";
import { get } from "aws-amplify/api";
import { useQuery } from "react-query";
import { formatDateTime } from "../../../common/useDateFunctions"

export const TODOS_QUERY_KEY = "TODOS_QUERY_KEY";

export const useTodosQuery = (patientUserId) => {
  return useQuery({
    queryKey: [TODOS_QUERY_KEY, patientUserId],
    retry: false,
    queryFn: listTodos.bind(this, patientUserId),
    staleTime: Infinity,
    placeholderData: [],
    enabled: !!patientUserId,
    select: (todos) => {
      return todos.map((todo) => {
        const dateInfo = formatDateTime(new Date(todo.todoDueDate));
        return {
          ...todo,
          todoDueDate: dateInfo,
        };
      })
    }
  });
};

const listTodos = async (patientUserId) => {
  const session = await fetchAuthSession();
  const { body } = await get({
    apiName: "todosapi",
    path: "/" + patientUserId,
    options: {
      headers: {
        Authorization: session.tokens.idToken.toString(),
      },
    },
  }).response;
  return await body.json();
};
